import React, { useEffect, useState } from 'react';
import HomeBanner from '../../components/HomeBanner';
// import NewsTicker from '../../components/NewsTicker';
// import DistInfo from './info';  design changes
import InfoTab from '../Home/InfoTab';
import { Container, Grid } from '@material-ui/core';
// import NewsNotice from "./news-and-notices"; design changes
// import ElectionCommissioner from '../../components/ElectionCommissioners';
import HomeGallery from '../Home/Gallery';
// import DistContact from './contact';
// import Activities from './activities';
// import DistSocialMedia from './socialmedia.jsx';
// import InformationSlider from './informationSlider';
import { useParams } from 'react-router';
import Branch, { stats } from '../../models/branch.model';
import { fetchBranchBySlug, fetchStatsBySlug } from '../../services/branchs.service';
import Preloader from '../../components/PreLoader';
import { fetchNews, fetchTickerNews } from '../../services/news.service';
import { useDispatch, useSelector } from 'react-redux';
import News from '../../models/news.model';
import NewsPicker from '../../components/NewsTicker';
import VoterPopulation from './voterPopulation';
import Maps from './map';
import LinksOptions from '../Home/LinksOptions';
import SocialFeeds from '../Home/SocialFeeds';
import Member from '../Home/HomeMembers';

import HomeJacketModal from '../../components/HomeJacket';

interface params {
  dist_slug: string,
}

interface state {
  news: {
    news: Array<News>,
    loading: false,
    tickerNews: any,
    important: Array<News>
  },
  // isProvince: boolean
}


const District: React.FC = (props) => {

  const { dist_slug } = useParams<params>();
  const [branch, setBranch] = useState<Branch | undefined>(undefined);
  const [statistics, setStat] = useState<stats | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const init = async () => {
    setLoading(true)
    const branch = await fetchBranchBySlug(dist_slug);
    setBranch(branch);
    const stats = await fetchStatsBySlug(dist_slug);
    setStat(stats);
    setLoading(false)
  }

  // store
  useEffect(() => {
    init();
    getTickerNews();
  }, [dist_slug]);//eslint-disable-line

  const state = useSelector((state: state) => {
    const { news } = state;
    return news;
  })
  const { loading: loadingNews, news, tickerNews, important } = state;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!news) dispatch(fetchNews(1, dist_slug));
  }, [dispatch]) //eslint-disable-line


  const getTickerNews = () => {
    dispatch(fetchTickerNews(1, dist_slug));
  }

  return (
    <>
      {
        !loading ?
          branch ?
            <>
              {/* dist nav bar */}

              {/* dist banner */}
              <NewsPicker news={tickerNews} loading={loadingNews} />

              <Container maxWidth="lg">
                <Grid container>
                  <Grid item xs={12} lg={6} md={6}>
                    <HomeBanner />
                  </Grid>
                  <Grid item xs={12} lg={6} md={6}>
                    <Maps branch={branch} />
                  </Grid>
                </Grid>
              </Container>


              {/* news ticker and info */}
              {/* <div className="bg-primary">
        <DistInfo district={branch} stats={stats}/>
      </div> */}

              <VoterPopulation stats={statistics} branch={branch} />

              {/* <InformationSlider/> */}

              {/* info and notices */}
              <div className="section-break-2">
                <Container maxWidth="lg">
                  <Grid container spacing={2}>
                    <Grid item xs={12} lg={8} md={6} xl={8}>
                      <InfoTab
                        news={news || []}
                        loadingNews={loadingNews}
                      // isProvince={props?.isProvince}
                      />
                    </Grid>
                    <Grid item xs={12} lg={4} md={6} xl={4}>
                      <Member />
                    </Grid>
                  </Grid>
                </Container>
              </div>

              <LinksOptions />

              {/* members
      <ElectionCommissioner/> */}

              {/* // gallery */}
              <HomeGallery />

              {/* conact activities and social */}
              {/* <div className="section-break-2">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4} md={6} xl={4}>
              <DistContact district={branch}/>
            </Grid>
            <Grid item xs={12} lg={4} md={6} xl={4}>
              <Activities/>
            </Grid>
            <Grid item xs={12} lg={4} md={6} xl={4}>
              <DistSocialMedia/>
            </Grid>
          </Grid>
        </Container>
      </div> */}
              <SocialFeeds />
            </>
            : <h3 className="text-center section-break-4 text-28-primary">
              Sorry district not found!!</h3>
          : <Preloader />
      }
      {important?.map((item, itemIndex) => {
        return (
          <HomeJacketModal
            open={true}
            data={item}
            itemIndex={itemIndex}
          />
        )
      })}

    </>
  );
}



export default District;